import { StitchError } from "../../src/spec/errors.js";
import { Project } from "../../src/project-ext.js";
/** Main entry point. Manages projects. */
export class Stitch {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Lists all Stitch projects accessible to the user. By default, it lists projects owned by the user.
     * Tool: list_projects
     */
    async projects() {
        try {
            const raw = await this.client.callTool("list_projects", {});
            return (raw?.projects || []).map((item) => new Project(this.client, item));
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Creates a new Stitch project. A project is a container for UI designs and frontend code.
     * Tool: create_project
     */
    async createProject(title) {
        try {
            const raw = await this.client.callTool("create_project", { title });
            return new Project(this.client, raw);
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /** Create a Project handle from an existing ID without an API call. */
    project(id) {
        return new Project(this.client, id);
    }
}
//# sourceMappingURL=stitch.js.map